import { useEffect, useRef, useState } from "react";
import {
  ErrorIcon,
  EyeCloseIcon,
  EyeOpenIcon,
  ValidIcon
} from "../../Assets/assets";
import { isPureNumber, isValidString } from "../../Services/validators.js";
import "./InputBox.css";
import { Regex } from "../../Utils/constants.js";

function InputBox(props) {
  const [value, setValue] = useState("");
  const [error, setError] = useState();
  const label = useRef(null);
  const inputRef = useRef(null);
  const previousLoadingState = useRef(false);
  const [complete, setComplete] = useState(false);

  //set complete status
  useEffect(() => {
    if (previousLoadingState.current === true && props.loading === false) {
      setComplete(true);
    } else {
      if (complete) setComplete(false);
    }
    previousLoadingState.current = props.loading;
    // eslint-disable-next-line
  }, [props.loading]);

  const handleTextInput = (event) => {
    setValue(event.target.value);
    props.onChange && props.onChange(event);
  };

  // set onchange value
  useEffect(() => {
    setValue(props.value);
    setComplete(false);
  }, [props.value]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const validators = (value) => {
    //return if props.value length is "0"
    let isValidInput = true;
    if (!value) {
      isValidInput = false;
      props.isValidInput && props.isValidInput(isValidInput);
      return;
    }
    if (String(value).length === 0) {
      return;
    }
    const emailValidate = /^[a-zA-Z0-9.]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/;
    const userNameValidate = /^[a-zA-Z. ]+$/;
    const phoneNumberValidate = /^[0-9+]+$/;

    if (typeof props.validation === "function") {
      if (props.validation(value)?.status === false) {
        isValidInput = false;
        inputRef.current.classList.add("error");
        if (!(props.validation(value)?.message === error)) {
          return setError(props.validation(value).message);
        }
      } else {
        if (error) {
          isValidInput = true;
          inputRef.current.classList.remove("error");
          return setError(null);
        }
      }
    } else if (
      props.name &&
      props.name.toLowerCase().includes("year") &&
      props.name !== "yearOfExperience"
    ) {
      if (
        !(
          typeof value === "string" &&
          value.trim().length !== 0 &&
          value.length === 4
        )
      ) {
        isValidInput = false;
        if (error === "Please enter a valid Year") return;
        setError("Please enter a valid Year");
      } else {
        if (error) {
          isValidInput = true;
          inputRef.current.classList.remove("error");
          return setError(null);
        }
      }
    } else {
      switch (props.name) {
        case "phoneNumber":
          if (value.length > 3 && value.length < 13) {
            isValidInput = false;
            if (error === "Please enter a valid phone number") return;
            setError("Please enter a valid phone number");
          } else if (value.length < 13) {
            isValidInput = false;
            props.isValidInput && props.isValidInput(isValidInput);
            return;
          } else if (isNaN(value)) {
            isValidInput = false;
            if (error === "Please enter a valid phone number") return;
            setError("Please enter a valid phone number");
          } else if (value.length > 15) {
            isValidInput = false;
            if (error === "Please enter a valid phone number") return;
            setError("Please enter a valid phone number");
          } else if (!phoneNumberValidate.test(value)) {
            isValidInput = false;
            if (error === "Please enter a valid phone number") return;
            setError("Please enter a valid phone number");
          } else if (value.trim().length > 13) {
            isValidInput = false;
            if (error === "Please enter a valid phone number") return;
            setError("Please enter a valid phone number");
          } else {
            if (error) {
              isValidInput = true;
              inputRef.current.classList.remove("error");
              return setError(null);
            }
          }
          break;

        case "fullName":
        case "userName":
          if (value === "") {
            isValidInput = false;
            if (error === "Please enter a valid Name") return;
            setError("Please enter a valid Name");
          } else if (value.length <= 1) {
            isValidInput = false;
            if (error === "Please enter a valid Name") return;
            setError("Please enter a valid Name");
          } else if (!isNaN(value)) {
            isValidInput = false;
            if (error === "Please enter a valid Name") return;
            setError("Please enter a valid Name");
          } else if (!userNameValidate.test(value)) {
            isValidInput = false;
            if (error === "Please enter a valid Name") return;
            setError("Please enter a valid Name");
          } else {
            if (error) {
              isValidInput = true;
              inputRef.current.classList.remove("error");
              return setError(null);
            }
          }
          break;

        case "email": {
          let _value = value ? `${value}`.trimStart() : "";
          _value = _value.trimEnd();
          if (!Regex.email.test(value)) {
            isValidInput = false;
            if (error === "Please enter a valid Email") return;
            setError("Please enter a valid Email");
          } else if (!emailValidate.test(_value)) {
            isValidInput = false;
            if (error === "Please enter a valid Email") return;
            setError("Please enter a valid Email");
          } else {
            if (error) {
              isValidInput = true;
              inputRef.current.classList.remove("error");
              return setError(null);
            }
          }
          break;
        }

        case "pincode": {
          if (!value) {
            isValidInput = false;
            if (error === "Please enter a valid pincode") return;
            setError("Please enter a valid pincode");
          }
          if (!(isPureNumber(value) && /^[1-9][0-9]{5}$/gm.test(value))) {
            isValidInput = false;
            if (error === "Please enter a valid pincode") return;
            setError("Please enter a valid pincode");
          } else {
            if (error) {
              isValidInput = true;
              inputRef.current.classList.remove("error");
              return setError(null);
            }
          }
          break;
        }

        case "date": {
          if (!value) {
            isValidInput = false;
            if (error === "Please enter a valid date") return;
            setError("Please enter a valid date");
          }
          const userEnteredDate = parseInt(value);
          const currentYear = new Date().getFullYear();
          const reducedYear = currentYear - 100;
          if (userEnteredDate < reducedYear || userEnteredDate > currentYear) {
            //Valid Date
            // return false;
            isValidInput = false;
            if (error === "Please enter a valid date") return;
            setError("Please enter a valid date");
          } else {
            if (error) {
              isValidInput = true;
              inputRef.current.classList.remove("error");
              return setError(null);
            }
          }
          break;
        }

        default:
          if (error) {
            isValidInput = true;
            inputRef.current.classList.remove("error");
            return setError(null);
          }
          break;
      }
    }

    if (props.isValidInput) {
      props.isValidInput(isValidInput);
    }

    if (isValidInput) {
      inputRef.current.classList.remove("error");
    } else {
      inputRef.current.classList.add("error");
    }
  };

  //for validation
  useEffect(() => {
    validators(value);
    // eslint-disable-next-line
  }, [value]);

  const InputSuffixIcon = () => {
    if (props.loading === true) {
      return (
        <div
          className="circular-loader"
          data-cy={`${props.name}-input-box-loader-icon`}
        />
      );
    } else if (typeof error === "string") {
      return (
        <div
          data-cy={`${props.name}-input-box-error-icon`}
          className={`height-width-1em padding-top-small padding-right-small ${props.iconClassNames}`}
        >
          <ErrorIcon />
        </div>
      );
    } else if (value && `${value}`.trim().length !== 0 && complete === true) {
      return (
        <div
          data-cy={`${props.name}-input-box-complete-icon`}
          className={`height-width-1em ${props.iconClassNames}`}
        >
          <ValidIcon />
        </div>
      );
    } else {
      return null;
    }
  };

  const InputInfo = () => {
    if (typeof error === "string" && error !== "") {
      return (
        <p className="font-size-smaller padding-top-small font-color-red">
          {error}
        </p>
      );
    } else if (typeof props.notes === "string") {
      return (
        <p
          className={` ${
            props.inputNotesClassName
              ? props.inputNotesClassName
              : "font-size-smaller font-color-tertiaryColor6 padding-top-small"
          } `}
        >
          {props.notes}
        </p>
      );
    } else {
      return <p className="font-size-smaller padding-top-small ">&nbsp;</p>;
    }
  };

  return (
    <div
      className={`inherit-parent-width  ${
        props.className ? props.className : ``
      }`}
    >
      <div
        className={`position-relative display-flex flex-align-items-end height-48px inherit-parent-width  ${
          props.disabled === true
            ? props.disabledBackgroundColor || " background-color-grey"
            : props.backgroundColor || ""
        } ${
          props.size === "half"
            ? "min-width-138px"
            : props.size === "small"
            ? "min-width-100px"
            : props.size === "smaller"
            ? "min-width-80px"
            : "min-width-250px"
        }`}
      >
        <div className="flex-center-children-horizontally font-size-medium inherit-parent-width">
          <div className="inherit-parent-width">
            <input
              onKeyUp={props.onKeyUp}
              aria-label={props.ariaLabel}
              placeholder={props.placeholder}
              id={props.name}
              data-cy={
                props["data-cy"] ? props["data-cy"] : `${props.name}-input-box`
              }
              readOnly={props.disabled}
              ref={inputRef}
              autoFocus={props.autoFocus}
              // defaultValue={props.defaultValue}
              value={props.value}
              step={props.step}
              style={props.style || {}}
              className={`${props.className || " "}
                ${
                  props.theme === "dark"
                    ? "font-color-tertiaryColor background-color-primary calendar-icon-color-invert"
                    : ""
                } 
                input-box background-transparent max-width-100-percentage inherit-parent-width font-size-medium padding-top-large padding-bottom-default display-block  input-box-border-bottom-default input-box-disabled-padding-left-5px border-radius-0 ${
                  typeof props.buttonTile === "string"
                    ? "padding-right-4p7-em"
                    : ""
                } ${
                (props.type === "date" || props.type === "time") &&
                "padding-right-0"
              } ${
                props.disabled === true
                  ? props.fontColor || " font-color-tertiaryColor6 disabled"
                  : props.fontColor || " font-color-tertiaryColor6"
              }`}
              autoComplete={props.autoComplete}
              min={props.minDate}
              max={
                props.type === "date"
                  ? props.maxDate
                    ? props.maxDate
                    : new Date().toISOString().split("T")[0]
                  : null
              }
              onFocus={() => {
                if (props.disabled) {
                  return;
                }
                if (label.current || props.placeholder) {
                  label.current?.classList.add("active");
                }
                inputRef.current?.classList.add("active");
              }}
              onBlur={(event) => {
                if (
                  !event.target.value &&
                  props.type !== "date" &&
                  props.type !== "time" &&
                  !props.placeholder
                ) {
                  label.current?.classList.remove("active");
                }
                if (event.target.value.trim().length === 0) {
                  setError(null);
                  inputRef.current?.classList.remove("error");
                }
                props.onOutOfFocus?.(event);
                inputRef.current?.classList.remove("active");
              }}
              type={props.type || null}
              name={props.name}
              onChange={handleTextInput}
              required={props.required === true ? true : false}
              inputMode={
                props.type === "number"
                  ? "numeric"
                  : props.inputMode
                  ? props.InputBox
                  : null
              }
            />
            <span className="input-box-border-bottom"></span>
            <label
              htmlFor={props.name}
              ref={label}
              className={` ${
                props.removeResponsive ? "" : "adaptive-font-size"
              } ${
                props.labelFontColor || "font-color-tertiaryColor6 "
              } input-box-label position-absolute font-size-medium  ${
                inputRef.current === document.activeElement ||
                props.value ||
                props.defaultValue ||
                (props.type === "number" && parseInt(props.value) > 0
                  ? true
                  : false) ||
                props.type === "time" ||
                props.type === "date" ||
                props.alwaysActive ||
                (props.autoFocus || typeof props.placeholder === "string") ===
                  true
                  ? "active"
                  : ""
              } ${props.disabled ? " disabled " : ""}
							`}
            >
              {props.label}
            </label>
            {typeof props.inputSuffixPlaceHolder === "string" && (
              <div className="position-absolute right-0 bottom-0 padding-bottom-default display-flex flex-align-items-center">
                <label
                  className={`font-color-tertiaryColor font-size-medium padding-left-small`}
                >
                  {props.inputSuffixPlaceHolder}
                </label>
              </div>
            )}
          </div>
          <div
            className={` position-absolute flex-align-items-center flex-justify-content-center min-width-1em absolute-center-self-vertically
					 	${props.type === "date" || props.type === "time" ? " right-1p5em" : " right-0"}
					 `}
          >
            {typeof props.inputSuffixPlaceHolder !== "string" && (
              <InputSuffixIcon />
            )}
            {/* {(props.name === "password" || props.name === "confirmPassword") && */}
            {props.type === "password" && (
              <TogglePasswordVisibility name={props.name} />
            )}

            {typeof props.buttonTile === "string" && (
              <button
                key="otp-button"
                id={props.buttonTileId}
                type={props.buttonType}
                data-cy={
                  props["button-data-cy"]
                    ? props["button-data-cy"]
                    : `${props.name}-input-box-suffix-button`
                }
                onClick={(event) => {
                  if (typeof props.onButtonClick === "function") {
                    props.onButtonClick(event);
                  }
                }}
                disabled={props.suffixButtonDisabled || isValidString(error)}
                style={{
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  paddingTop: "6px",
                  paddingBottom: "6px"
                }}
                className={`${props.buttonClassName} ${
                  props.buttonFontColor || "font-color-tertiaryColor6"
                } font-weight-normal margin-left-medium margin-right-medium  font-size-smaller background-transparent margin-left-8px suffix-button-border border-radius-default text-transform-uppercase`}
              >
                {props.buttonTile}
              </button>
            )}
          </div>
        </div>
      </div>
      <InputInfo />
    </div>
  );
}
export default InputBox;

const TogglePasswordVisibility = (props) => {
  const [toggle, setToggle] = useState(false);

  const data = document.querySelector(`input[name=${props.name}]`);
  return (
    <>
      {data?.type === "password" ? (
        <div
          className="padding-left-large"
          key={toggle}
          onClick={() => {
            if (data) {
              data.type = "text";
              setToggle(true);
            }
          }}
        >
          <EyeOpenIcon color="var(--tertiaryColor6)" />
        </div>
      ) : (
        <div
          className="padding-left-default"
          key={toggle}
          onClick={() => {
            if (data) {
              data.type = "password";
            }
            setToggle(false);
          }}
        >
          <EyeCloseIcon color="var(--tertiaryColor6)" />
        </div>
      )}
    </>
  );
};
